/* React */
import React from "react";

/* Stylesheet */
import styles from "./EmptyDataContainer.module.scss";

/* Interfaces */
interface EmptyDataProps {
  scssProps?: ScssProps;
}

interface ScssProps {
  color?: string;
  icon?: {
    height?: string;
    width?: string;
  };
}

const EmptyDataContainer: React.FC<EmptyDataProps> = ({
  scssProps,
}) => {
  return (
    <div className={styles.empty_data_container}>
      <div className={styles.block_container}>
        <img
          style={{
            height: scssProps?.icon?.height,
            width: scssProps?.icon?.width,
          }}
          className={styles.image}
          src={"/assets/icons/no-data.svg"}
        />
      </div>
    </div>
  );
};

export default EmptyDataContainer;
